export const ANNOTATIONS_SETTINGS_SHOW = 'showAnnotations';
export const ANNOTATIONS_SETTINGS_TYPE = 'type';
export const ANNOTATIONS_SETTINGS_SUB_TYPES = 'subTypes';
export const ANNOTATIONS_SETTINGS_MINE_ONLY = 'mineOnly';
